import React, { useState, useEffect, useRef } from "react";
import { Collapse, Container } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import classname from "classnames";
import { withTranslation } from "react-i18next";

const Navbar = ({ t, menuOpen, toggleMenu, setMenuOpen }) => {
    const [activeDropdown, setActiveDropdown] = useState(null);
    const navRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        setActiveDropdown(null);
    }, [location.pathname]);

    const closeAllMenus = () => {
        setActiveDropdown(null);
        if (typeof setMenuOpen === "function") {
            setMenuOpen(false);
        } else if (typeof toggleMenu === "function" && menuOpen) {
            toggleMenu();
        }
    };

    const toggleDropdown = (name, e) => {
        e.preventDefault();
        e.stopPropagation();
        setActiveDropdown(activeDropdown === name ? null : name);
    };

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (navRef.current && !navRef.current.contains(e.target)) {
                setActiveDropdown(null);
            } else if (!e.target.closest(".dropdown-toggle")) {
                setActiveDropdown(null);
            }
        };
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    const is = (path) => location.pathname === path;
    const startsWith = (path) => location.pathname.startsWith(path);

    return (
        <React.Fragment>
            <div className="topnav">
                <Container fluid>
                    <nav className="navbar navbar-light navbar-expand-lg topnav-menu" ref={navRef}>
                        <Collapse isOpen={menuOpen} className="navbar-collapse" id="topnav-menu-content">
                            <ul className="navbar-nav">

                                {/* Dashboard */}
                                <li className="nav-item">
                                    <Link
                                        className={classname("nav-link", {
                                            active: is("/admin/dashboard") || is("/"),
                                        })}
                                        to="/admin/dashboard"
                                        onClick={closeAllMenus}
                                    >
                                        <i className="ri-dashboard-line me-2"></i>
                                        {t("Dashboard")}
                                    </Link>
                                </li>

                                {/* Web Audit */}
                                <li className="nav-item">
                                    <Link
                                        className={classname("nav-link", {
                                            active: startsWith("/admin/webaudit"),
                                        })}
                                        to="/admin/webaudit"
                                        onClick={closeAllMenus}
                                    >
                                        <i className="ri-search-eye-line me-2"></i>
                                        {t("Web Audit")}
                                    </Link>
                                </li>

                                {/* Lucky Draw */}
                                <li className="nav-item">
                                    <Link
                                        className={classname("nav-link", {
                                            active: startsWith("/admin/luckydraw"),
                                        })}
                                        to="/admin/luckydraw"
                                        onClick={closeAllMenus}
                                    >
                                        <i className="ri-gift-line me-2"></i>
                                        {t("Lucky Draw")}
                                    </Link>
                                </li>

                                {/* Office */}
                                <li className="nav-item dropdown">
                                    <Link
                                        className={classname("nav-link dropdown-toggle arrow-none", {
                                            active: startsWith("/admin/office") && !startsWith("/admin/office/website"),
                                        })}
                                        to="#"
                                        onClick={(e) => toggleDropdown("office", e)}
                                    >
                                        <i className="ri-building-line me-2"></i>
                                        {t("Office")}
                                        <div className="arrow-down"></div>
                                    </Link>
                                    <div
                                        className={classname("dropdown-menu", {
                                            show: activeDropdown === "office",
                                        })}
                                    >
                                        <Link to="/admin/office/departments" className="dropdown-item" onClick={closeAllMenus}>
                                            <i className="ri-team-line me-2 text-muted"></i>
                                            {t("Departments")}
                                        </Link>
                                        <Link to="/admin/office/designations" className="dropdown-item" onClick={closeAllMenus}>
                                            <i className="ri-award-line me-2 text-muted"></i>
                                            {t("Designations")}
                                        </Link>
                                        <Link to="/admin/office/staff" className="dropdown-item" onClick={closeAllMenus}>
                                            <i className="ri-user-star-line me-2 text-muted"></i>
                                            {t("Staff")}
                                        </Link>
                                    </div>
                                </li>

                                {/* Website */}
                                <li className="nav-item dropdown">
                                    <Link
                                        className={classname("nav-link dropdown-toggle arrow-none", {
                                            active: startsWith("/admin/office/website"),
                                        })}
                                        to="#"
                                        onClick={(e) => toggleDropdown("website", e)}
                                    >
                                        <i className="ri-global-line me-2"></i>
                                        {t("Website")}
                                        <div className="arrow-down"></div>
                                    </Link>
                                    <div
                                        className={classname("dropdown-menu", {
                                            show: activeDropdown === "website",
                                        })}
                                    >
                                        <Link to="/admin/office/website/blogs" className="dropdown-item" onClick={closeAllMenus}>
                                            <i className="ri-article-line me-2 text-muted"></i>
                                            {t("Blogs")}
                                        </Link>
                                        <Link to="/admin/office/website/portfolios" className="dropdown-item" onClick={closeAllMenus}>
                                            <i className="ri-gallery-line me-2 text-muted"></i>
                                            {t("Portfolio")}
                                        </Link>
                                    </div>
                                </li>

                            </ul>
                        </Collapse>
                    </nav>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withTranslation()(Navbar);
